import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Utils } from 'src/app/commun/Utils';
import { AbstractService } from 'src/app/shared/services/abstract.service';
import { GenericHttpClient } from 'src/app/shared/services/generic-http-client';
import { SourceDevice } from 'src/app/shared/models/SourceDevice';

@Injectable({
  providedIn: 'root'
})
export class ListDeclarationsMlvService extends AbstractService {

  constructor(private http: GenericHttpClient) { super(); }

  getListDeclarationsMlv(idInterne, pageSize, offset, filters): Observable<any> {
    let sourceDevice = SourceDevice.WEB;
    if (window.innerWidth < environment.MOBILE_BREAK_POINT) {
      sourceDevice = SourceDevice.MOBILE;
    }
    let parametersUrl = 'historique/public/listDeclarationsMlv/' + idInterne + '?pageSize=' + pageSize + '&offset=' + offset + '&sourceDevice=' + sourceDevice;
    if (filters) {
      if (filters.codeSens) {
        parametersUrl += '&codeSens=' + filters.codeSens;
      }
      if (filters.mlv) {
        parametersUrl += '&mlv=' + filters.mlv;
      }
      if (filters.resultatSelectivite) {
        parametersUrl += '&resultatSelectivite=' + filters.resultatSelectivite;
      }
      if (filters.valeur) {
        parametersUrl += '&valeur=' + filters.valeur;
      }

      if (filters.dateDebut) {
        parametersUrl += '&dateDebut=' + Utils.formatDate(filters.dateDebut);
      }
      if (filters.dateFin) {
        parametersUrl += '&dateFin=' + Utils.formatDate(filters.dateFin);
      }
    }
    return this.http.httpGet(environment.SERVER_URL + parametersUrl);
  }

  getListHistoriqueDum(numDum, sourceDevice: string): Observable<any> {
    let parametersUrl = 'historique/public/findHistoriqueDum/' + numDum + '/' + sourceDevice;
    return this.http.httpGet(environment.SERVER_URL + parametersUrl);
  }


}
